export default __webpack_public_path__ + "static/media/jewelry-bright-winter.3fe19738.png";